import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { BaseService } from '../../../shared/services/base.service';
import { SummaryPrivateFinancingModel } from '../models/summary-private-financing.model';



@Injectable()
export class PrivateFinancingService extends BaseService<SummaryPrivateFinancingModel,SummaryPrivateFinancingModel> {
  constructor(http: HttpClient) {
    super(http, '/api/v2/private-financings');
  }

}
